import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

import storeModules from "./modules";

import storePlugins from "./plugins";

Vue.use(Vuex);

export let store;

export function initialize() {
  if (!store) {
    store = new Vuex.Store({
      modules: storeModules,
      plugins: [
        createPersistedState({
          paths: ["schoolAuth", "fcm", "chat"]
        }),
        ...storePlugins
      ]
    });
  }

  return store;
}
